import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconTrash2 = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--trash-2")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M14,1 C15.6568542,1 17,2.34314575 17,4 L17,4 L17,5 L21,5 C21.5128358,5 21.9355072,5.38604019 21.9932723,5.88337887 L22,6 C22,6.55228475 21.5522847,7 21,7 L21,7 L20,7 L20,20 C20,21.5976809 18.75108,22.9036609 17.1762728,22.9949073 L17,23 L7,23 C5.34314575,23 4,21.6568542 4,20 L4,20 L4,7 L3,7 C2.48716416,7 2.06449284,6.61395981 2.00672773,6.11662113 L2,6 C2,5.44771525 2.44771525,5 3,5 L3,5 L7,5 L7,4 C7,2.40231912 8.24891996,1.09633912 9.82372721,1.00509269 L10,1 Z M18,7 L6,7 L6,20 C6,20.5128358 6.38604019,20.9355072 6.88337887,20.9932723 L7,21 L17,21 C17.5522847,21 18,20.5522847 18,20 L18,20 L18,7 Z M10,10 C10.5522847,10 11,10.4477153 11,11 L11,11 L11,17 C11,17.5522847 10.5522847,18 10,18 C9.44771525,18 9,17.5522847 9,17 L9,17 L9,11 C9,10.4477153 9.44771525,10 10,10 Z M14,10 C14.5522847,10 15,10.4477153 15,11 L15,11 L15,17 C15,17.5522847 14.5522847,18 14,18 C13.4477153,18 13,17.5522847 13,17 L13,17 L13,11 C13,10.4477153 13.4477153,10 14,10 Z M14,3 L10,3 C9.44771525,3 9,3.44771525 9,4 L9,4 L9,5 L15,5 L15,4 C15,3.48716416 14.6139598,3.06449284 14.1166211,3.00672773 L14,3 Z" id="icon--centivo--trash-2"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1961.000000, -1198.000000)"/>
          <g id="Icon/trash-2">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--trash-2"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--trash-2"/>
          </g>
      </g>
  </IconWrapper>
)
